import React from 'react';
import './Logo.css';

export default function Logo() {
  return (
    <div className="logo-container">
      <img 
        src="/images/sefarium_logo.png" 
        alt="SEFARIUM PREMIUM TRAVEL SERVICES" 
        className="logo-image"
      />
    </div>
  );
}

